<template>
  <el-dialog :title="titie" :visible.sync="dialogVisible" width="80%" custom-class="wait-dialog">
					<div style="display: flex;align-items: center; justify-content:center;"><a style="text-decoration: none; font-size:14px; "
						 href="http://wpa.qq.com/msgrd?v=3&amp;uin=2629198267&amp;site=qq&amp;menu=yes" target="_blank"><img src="@/assets/images/qq(2).png"
							 style="width: 21.33%">
							<p style="margin-left:10px ;color: #349CE3;display: initial;font-size:14px;">2629198267</p>
						</a></div>
					<div style="display: flex;align-items: center; justify-content:center; margin-top:20px;"><img alt="" src="@/assets/images/phone.png"
						 style="width: 9.33%">
						<p style="margin-left:10px;color: #349CE3;font-size:14px;">021-54011298</p>
					</div>
				</el-dialog>
</template>

<script>
export default {
    data() {
        return {

            titie: '感谢关注MoPaaS人工智能平台，平台暂未开放，如需试用，请联系客服。',
            dialogVisible: false
        }
    },
    methods: {
        
        showDialog() {
            this.dialogVisible = true;
        }
    }
}
</script>

<style>
.wait-dialog .el-dialog__header {
    padding: 20px 40px 10px;
}
/* .wait-dialog .el-dialog__title {
    font-size: 4.76375vw;
} */
</style><style></style>


// WEBPACK FOOTER //
// src/page/h5/Wait.vue